// Filtros compartidos de la búsqueda: rango de seguidores e idioma.
export type FollowerRange = { label: string; min: number; max: number };

/** max = 0 significa sin tope. */
export const FOLLOWER_RANGES: FollowerRange[] = [
  { label: "Cualquier cantidad", min: 0, max: 0 },
  { label: "0 – 100", min: 0, max: 100 },
  { label: "100 – 500", min: 100, max: 500 },
  { label: "500 – 1.000", min: 500, max: 1000 },
  { label: "1.000 – 5.000", min: 1000, max: 5000 },
  { label: "5.000 – 10.000", min: 5000, max: 10000 },
  { label: "10.000 – 50.000", min: 10000, max: 50000 },
  { label: "50.000 – 100.000", min: 50000, max: 100000 },
  { label: "100.000 – 500.000", min: 100000, max: 500000 },
  { label: "500.000 – 1 M", min: 500000, max: 1000000 },
  { label: "Más de 1 M", min: 1000000, max: 0 },
];

export type SearchLanguage = "es" | "es,pt" | "pt" | "any";

export const SEARCH_LANGUAGES: { value: SearchLanguage; label: string }[] = [
  { value: "es", label: "Español" },
  { value: "es,pt", label: "Español y portugués" },
  { value: "pt", label: "Portugués" },
  { value: "any", label: "Todos los idiomas" },
];

export function languagesFor(value: SearchLanguage): string[] {
  return value === "any" ? [] : value.split(",");
}

export function matchesFollowerRange(followers: number, label: string): boolean {
  const r = FOLLOWER_RANGES.find((x) => x.label === label);
  if (!r || (r.min === 0 && r.max === 0)) return true;
  if (followers < r.min) return false;
  if (r.max && followers > r.max) return false;
  return true;
}